import { useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UILink from 'UIComponents/link/UILink';
import H5 from 'UIComponents/elements/headings/H5';
import { getSettingUrl } from '../../routing/utils/externalUrls';
import { getLanguageNameFromCode } from '../../utils/langUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LanguagesFilterPopoverBody = styled.div.withConfig({
  displayName: "TranslationLanguagesFilter__LanguagesFilterPopoverBody",
  componentId: "sc-98opin-0"
})(["max-width:416px;padding:30px 25px 20px;"]);
export default function TranslationLanguagesFilter(props) {
  const {
    options,
    value,
    articleLanguage
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const onChange = (lang, newChecked) => {
    if (newChecked) {
      props.onChange([...value, lang]);
    } else {
      const newValue = [...value];
      newValue.splice(newValue.indexOf(lang), 1);
      props.onChange(newValue);
    }
  };
  const onApply = () => {
    setIsOpen(false);
    props.onApply();
  };
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "knowledgeContentUI.translationLanguagesFilter.linkPrefix"
    }), /*#__PURE__*/_jsx(UIPopover, {
      open: isOpen,
      placement: "bottom right",
      content: /*#__PURE__*/_jsxs(LanguagesFilterPopoverBody, {
        children: [/*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "knowledgeContentUI.translationLanguagesFilter.popover.heading"
          })
        }), /*#__PURE__*/_jsx(UIGrid, {
          children: options.map(opt => {
            const checked = value.includes(opt.value);
            const isArticleLanguage = opt.value === articleLanguage;
            return /*#__PURE__*/_jsx(UIGridItem, {
              className: "p-bottom-2",
              size: {
                xs: 6
              },
              children: /*#__PURE__*/_jsx(UICheckbox, {
                checked: opt.forceEnabled || checked,
                onChange: () => onChange(opt.value, !checked),
                readOnly: opt.forceEnabled || isArticleLanguage,
                children: getLanguageNameFromCode(opt.value)
              })
            }, opt.value);
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "knowledgeContentUI.translationLanguagesFilter.popover.addMoreInSettings_jsx",
            elements: {
              Link: linkProps => /*#__PURE__*/_jsx(UILink, {
                href: getSettingUrl(''),
                children: linkProps.children
              })
            }
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "m-top-4",
          children: [/*#__PURE__*/_jsx(UIButton, {
            onClick: onApply,
            className: "m-right-4",
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.translationLanguagesFilter.popover.applyButton"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            onClick: () => setIsOpen(false),
            use: "tertiary-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "knowledgeContentUI.translationLanguagesFilter.popover.cancelButton"
            })
          })]
        })]
      }),
      children: /*#__PURE__*/_jsx(UIButton, {
        onClick: () => setIsOpen(!isOpen),
        use: "transparent",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "knowledgeContentUI.translationLanguagesFilter.linkText",
          options: {
            selectedCount: value.length,
            total: options.length
          }
        })
      })
    })]
  });
}